import { Block } from "@components/block";
import { Grid, GridCol } from "@components/grid";
import styles from "./finance.module.scss";
import { Button } from "@components/button";
import { useAdminBalances } from "@features/admin/finance";
import { useEffect, useState } from "react";
import { FlexLoader } from "@components/loader";
import { AddWalletModal } from "@components/admin-add-wallet";
import { useBoolState } from "@hooks/use-bool-state";
import { formatUsdt } from "@helpers/format";
import { EllipsisText } from "@components/ellipsis-text";

export const AdminFinancePage = () => {
  const [isModalOpen, showModal, hideModal] = useBoolState(false);

  const {
    state,
    getAdminBalances,
    getTradeBalance,
    getAdminWalletsForWithdrawals,
    getAdminWallet,
    deleteAdminWalletsForWithdrawals,
  } = useAdminBalances();

  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");

  useEffect(() => {
    getAdminBalances();
    getTradeBalance();
    getAdminWalletsForWithdrawals();
    getAdminWallet();
    const currentDate = new Date();

    const endDate = currentDate.toISOString().split("T")[0];
    setDateEnd(endDate);
    currentDate.setDate(currentDate.getDate() - 90);
    const startDate = currentDate.toISOString().split("T")[0];
    setDateStart(startDate);
  }, []);

  const update = () => {
    getAdminBalances();
  };

  const show = () => {
    const startDate = new Date(dateStart);
    startDate.setHours(0, 0, 0);
    const start = Math.floor(startDate.getTime() / 1000);

    const endDate = new Date(dateEnd);
    endDate.setHours(23, 59, 59, 0);
    const end = Math.floor(endDate.getTime() / 1000);

    // Calculate the difference in seconds
    const differenceInSeconds = end - start;

    // 90 days in seconds (90 days * 24 hours * 60 minutes * 60 seconds)
    const ninetyDaysInSeconds = 90 * 24 * 60 * 60;

    if (differenceInSeconds > ninetyDaysInSeconds) {
      alert("Максимальный период 90 дней");
    } else {
      getTradeBalance({ date_start: start, date_end: end });
    }
  };

  const deleteWalletWithdrawals = (val: string) => {
    deleteAdminWalletsForWithdrawals({ address: val }).then(() => {
      getAdminWalletsForWithdrawals();
    });
  };

  return (
    <>
      <div className={styles.top}>
        <Button className={styles.update + " " + styles.btn} onClick={update}>
          Обновить
        </Button>
        <Grid>
          <GridCol span={4}>
            <Block className={styles.financeBlock}>
              {state.loading ? (
                <FlexLoader />
              ) : (
                <>
                  <div>Settlment по всем мерчам</div>
                  <span>{formatUsdt(state.balances?.merch_balance ?? 0)}</span>
                </>
              )}
            </Block>
          </GridCol>
          <GridCol span={4}>
            <Block className={styles.financeBlock}>
              {state.loading ? (
                <FlexLoader />
              ) : (
                <>
                  <div>Замороженные балансы трейдеров</div>
                  <span>{formatUsdt(state.balances?.frozen_balance ?? 0)}</span>
                </>
              )}
            </Block>
          </GridCol>
          <GridCol span={4}>
            <Block className={styles.financeBlock}>
              {state.loading ? (
                <FlexLoader />
              ) : (
                <>
                  <div>Доходы трейдеров</div>
                  <span>{formatUsdt(state.balances?.ern_balance ?? 0)}</span>
                </>
              )}
            </Block>
          </GridCol>
          <GridCol span={4}>
            <Block className={styles.financeBlock}>
              {state.loading ? (
                <FlexLoader />
              ) : (
                <>
                  <div>Доходы за все время</div>
                  <span>{formatUsdt(state.balances?.our_balance ?? 0)}</span>
                </>
              )}
            </Block>
          </GridCol>
          <GridCol span={4}>
            <Block className={styles.financeBlock}>
              {state.tradeBalanceLoading ? (
                <FlexLoader />
              ) : (
                <>
                  <div>Доходы агентов</div>
                  <span>{formatUsdt(state.balances?.agent_team_lead_balances ?? 0)}</span>
                </>
              )}
            </Block>
          </GridCol>
        </Grid>
      </div>
      <div style={{ paddingBottom: "10px" }}>
        <div className={styles.formFields}>
          <label>
            Дата начала
            <br />
            <input
              type="date"
              className={styles.date}
              value={dateStart}
              onChange={(e) => {
                setDateStart(e.target.value);
              }}
            />
          </label>
          <label>
            Дата конца
            <br />
            <input
              type="date"
              className={styles.date}
              value={dateEnd}
              onChange={(e) => {
                setDateEnd(e.target.value);
              }}
            />
          </label>
          <Button className={styles.btn} onClick={show}>
            Показать
          </Button>
        </div>
        <Grid>
          <GridCol span={3}>
            <Block className={styles.financeBlock}>
              {state.tradeBalanceLoading ? (
                <FlexLoader />
              ) : (
                <>
                  <div>Прибыль</div>
                  <span>
                    {formatUsdt(state.tradeBalance?.our_balance ?? 0)}
                  </span>
                </>
              )}
            </Block>
          </GridCol>
          <GridCol span={3}>
            <Block className={styles.financeBlock}>
              {state.tradeBalanceLoading ? (
                <FlexLoader />
              ) : (
                <>
                  <div>Сумма сделок</div>
                  <span>{formatUsdt(state.tradeBalance?.pay_in ?? 0)}</span>
                </>
              )}
            </Block>
          </GridCol>
          <GridCol span={3}>
            <Block className={styles.financeBlock}>
              {state.tradeBalanceLoading ? (
                <FlexLoader />
              ) : (
                <>
                  <div>Сумма вывода</div>
                  <span>{formatUsdt(state.tradeBalance?.pay_out ?? 0)}</span>
                </>
              )}
            </Block>
          </GridCol>
        </Grid>
      </div>
      <Block className={styles.walletsBlock}>
        {state.walletsLoading ? (
          <FlexLoader />
        ) : (
          <>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th colSpan={2}>
                    <div className={styles.header}>
                      <div>Кошельки отправка</div>
                      <span onClick={showModal}>Добавить</span>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>Адрес</th>
                </tr>
              </thead>
              <tbody>
                {state.withdrawalWallets?.map((wallet, index) => (
                  <tr key={index}>
                    <td>
                      <EllipsisText text={wallet} copy startLength={100} />
                    </td>
                    <td>
                      <span
                        onClick={() => deleteWalletWithdrawals(wallet)}
                        style={{ color: "red", cursor: "pointer" }}
                      >
                        Delete
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <table className={styles.table}>
              <thead>
                <tr>
                  <th colSpan={2}>
                    <div className={styles.header}>
                      <div>Кошельки прием</div>
                      <span onClick={showModal}>Добавить</span>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th>Адрес</th>
                </tr>
              </thead>
              <tbody>
                {state.wallets?.map((wallet, index) => (
                  <tr key={index}>
                    <td>
                      <EllipsisText text={wallet} copy startLength={100} />
                    </td>
                    <td>
                      <span>Delete</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </Block>
      <AddWalletModal isModalOpen={isModalOpen} hideModal={hideModal} />
    </>
  );
};
